import React from "react";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";

const CourseCard = React.memo(
	({ course, userRole, onEdit, onDelete, onClick }) => (
		<div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 pl-cr" key={course.id}>
			<Card
				className="fadeup d-flex flex-column"
				style={{ width: "100%", height: "100%" }}>
				<button
					type="button"
					style={{ all: "unset", cursor: "pointer" }}
					onClick={() => onClick(course.id)}>
					<img
						style={{ width: "100%", height: "150px" }}
						src={course.courseimage}
						alt={course.coursetitle}
						loading="lazy"
						onError={(e) => {
							e.target.src = "../images/common-couse-image.png";
						}}
					/>
				</button>

				<Card.Body
					className="d-flex flex-column"
					style={{
						width: "100%",
						height: "100%",
						justifyContent: "space-between",
					}}>
					<div>
						<a
							className="text-course card-cost"
							href={`/courseinfo/${course.id}`}
							style={{ cursor: "pointer", padding: "0" }}>
							{course.coursetitle}
						</a>
						{course.duration !== "" && (
							<div className="card-duration">
								<i
									className="fa fa-clock "
									style={{ padding: "", color: "" }}></i>
								<span className="card-duration">
									{" "}
									Duration: &nbsp;&nbsp;
									<span>{course.duration}&nbsp;</span>Hrs
								</span>
							</div>
						)}
						{course.language?.name !== "English" && (
							<div className="card-duration" style={{ fontSize: "12px" }}>
								Language: &nbsp;&nbsp;
								<span style={{ textDecoration: "underline" }}>
									{course.language?.name}
								</span>
							</div>
						)}
						<div className="card-duration">
							<span className="card-duration">
								{course.cost === "" ? "Free" : `₹${course.cost}`}
							</span>
						</div>
					</div>
					{userRole === "Admin" && (
						<div className="d-grid col-12 d-flex justify-content-around">
							<Button
								className="btn btn-warning"
								style={{
									fontSize: "13px",
									borderRadius: "4px",
									border: "none",
								}}
								onClick={() => onEdit(course)}>
								<i className="fas fa-edit"></i> Edit course
							</Button>
							<Button
								style={{
									background: "#E23F1C",
									fontSize: "13px",
									borderRadius: "4px",
									border: "none",
								}}
								onClick={() => onDelete(course)}>
								<i className="fa fa-trash" aria-hidden="true"></i> Delete course
							</Button>
						</div>
					)}
				</Card.Body>
			</Card>
		</div>
	)
);

export default CourseCard;
